module.exports = __webpack_public_path__ + "static/img/IMG_0457.bc84c147.jpg";